import { Component, OnInit, OnDestroy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { StoreService } from "./services/store.service";
import { CartService } from "./services/cart.service";
import { NgxSmartModalService } from "ngx-smart-modal";
import { CategoriasService } from "./services/categorias.service";
import { ArticulosService } from "./services/articulos.service";
import { catchError, map, switchMap } from "rxjs/operators";
import { Pais } from "./enums";
import {
  SUSCRIPTION_MODAL_ID,
  SubscriptionModalComponent,
} from "./shared/modals/subscription-modal/subscription-modal.component";
import { USER_LANG } from "./shared/modals/lang-modal/lang-modal.component";
import { SuscripcionesService } from "./services/suscripciones.service";
import { Subject, of } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly onDestroy$ = new Subject<void>();
  constructor(
    private storeService: StoreService,
    private cartService: CartService,
    private modalService: NgxSmartModalService,
    private _categorias: CategoriasService,
    private _articulos: ArticulosService,
    private _suscripciones: SuscripcionesService,
    private _translate: TranslateService
  ) {
    this.storeService.lineasObservable$.subscribe(() => {});
  }

  ngOnInit() {
    this.initLineas().subscribe(() => {
      this.initLang();
      this.initCart();

      this._translate.onLangChange.pipe(
        switchMap(({ lang }) => {
          return this._articulos.categorias(lang === "es" ? Pais.Mexico : Pais.EstadosUnidos);
        }),
        takeUntil(this.onDestroy$)
      ).subscribe((categorias) => {
        this._categorias.categorias = categorias;

        if (this._translate.currentLang === "es") {
          this.storeService.lineas = this.storeService.lineasMX;
        } else {
          this.storeService.lineas = this.storeService.lineasUSA;
        }
      });
    });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    localStorage.removeItem("bat");
  }

  initLineas() {
    return this.storeService.getLineas({ where: { status: "activo" } }).pipe(
      map((lineas: any[]) => {
        this.storeService.lineasUSA = lineas.filter((l) => l.ecommerce === "USA");
        this.storeService.lineasMX = lineas.filter((l) => l.ecommerce === "MX");
        this.storeService.lineasObservable$.next(lineas);
      }),
      catchError((err) => {
        console.error('Error al cargar lineas:', err);
        return of(null);
      }),
      takeUntil(this.onDestroy$)
    );
  }

  initLang() {
    this.storeService.getCountryFromIp().pipe(
      switchMap((countryResponse: any) => {
        const country = countryResponse.country.toLowerCase();
        const preferredLang = localStorage.getItem(USER_LANG);
        const defaultLang = preferredLang
          ? preferredLang
          : country === "mx"
          ? "es"
          : "en";

        this._translate.use(defaultLang);
        this._translate.setDefaultLang(defaultLang);
        return this._articulos.categorias(defaultLang === "es" ? Pais.Mexico : Pais.EstadosUnidos);
      }),
      takeUntil(this.onDestroy$)
    ).subscribe((categorias) => {
      this._categorias.categorias = categorias;
      if (this._translate.currentLang === "es") {
        this.storeService.lineas = this.storeService.lineasMX;
      } else {
        this.storeService.lineas = this.storeService.lineasUSA;
      }
      // this.openSubscriptionModal();
    });
  }

  initCart() {
    this.cartService.loadCart();
  }

  openSubscriptionModal() {
    if (!this._suscripciones.suscripcion)
      setTimeout(() => {
        this.modalService
          .create(SUSCRIPTION_MODAL_ID, SubscriptionModalComponent, {
            closable: true,
            customClass: "sub-modal",
          })
          .open()
          .onAnyCloseEventFinished.subscribe(() => {
            this._suscripciones.suscripcion = "SKIPED";
            this.modalService.removeModal(SUSCRIPTION_MODAL_ID);
          });
      }, 2000);
  }
}
